"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _UIFolderNav = _interopRequireDefault(require("UIComponents/nav/UIFolderNav"));

var _UIFolderNavItem = _interopRequireDefault(require("UIComponents/nav/UIFolderNavItem"));

var _FoldersAndFiles = require("../utils/FoldersAndFiles");

var _propTypes2 = require("../constants/propTypes");

var _Constants = require("../Constants");

var FolderTree = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(FolderTree, _Component);

  function FolderTree() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, FolderTree);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(FolderTree)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleHomeClick = function () {
      var onSelect = _this.props.onSelect;
      onSelect((0, _FoldersAndFiles.getHomeFolder)());
    };

    _this.renderFolder = function (folder) {
      var _this$props = _this.props,
          onSelect = _this$props.onSelect,
          ancestors = _this$props.ancestors,
          exclusions = _this$props.exclusions;

      if (exclusions.contains(folder.id)) {
        return null;
      }

      var selectedFolder = _this.getSelectedFolder();

      var children = folder.children;

      var handleClick = function handleClick() {
        _this.props.fetchFoldersByParentId(folder.id);

        onSelect(_this.getFolder(folder.id));
      };

      var open = selectedFolder.get('id') === folder.id || ancestors.has(folder.id);
      return _react.default.createElement(_UIFolderNavItem.default, {
        key: folder.id,
        value: folder.id,
        title: folder.name,
        active: selectedFolder.get('id') === folder.id,
        open: open,
        onClick: handleClick,
        iconLeft: open && children ? 'folderOpen' : 'folder'
      }, children && children.length > 0 && _this.renderChildren(children));
    };

    return _this;
  }

  (0, _createClass2.default)(FolderTree, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.fetchFoldersByParentId(_Constants.ROOT_FOLDER_ID);
    }
  }, {
    key: "getFolder",
    value: function getFolder(id) {
      var folders = this.props.folders;
      return folders.get(id);
    }
  }, {
    key: "getSelectedFolder",
    value: function getSelectedFolder() {
      var selectedFolder = this.props.selectedFolder;
      return selectedFolder;
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(children) {
      return children.map(this.renderFolder);
    }
  }, {
    key: "render",
    value: function render() {
      var tree = this.props.tree;
      var selectedFolder = this.getSelectedFolder();
      return _react.default.createElement(_UIFolderNav.default, null, _react.default.createElement(_UIFolderNavItem.default, {
        open: true,
        active: selectedFolder === (0, _FoldersAndFiles.getHomeFolder)(),
        title: tree.name,
        onClick: this.handleHomeClick
      }, this.renderChildren(tree.children)));
    }
  }]);
  return FolderTree;
}(_react.Component);

exports.default = FolderTree;
FolderTree.propTypes = {
  ancestors: _propTypes2.orderedMapProp.isRequired,
  exclusions: _propTypes.default.instanceOf(_immutable.default.Set).isRequired,
  onSelect: _propTypes.default.func.isRequired,
  fetchFoldersByParentId: _propTypes.default.func.isRequired,
  selectedFolder: _propTypes.default.instanceOf(_immutable.default.Map),
  // POJO for performance reasons and to more easily support references
  tree: _propTypes.default.object.isRequired,
  folders: _propTypes2.orderedMapProp.isRequired
};
FolderTree.defaultProps = {
  exclusions: new _immutable.default.Set()
};
module.exports = exports.default;